import React, { useEffect, useState, useContext } from 'react';
import Header from '../Header/AppHeader';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import DataTable from '../Common/DataTableList';
import baseURL from '../Common/Config';
import {
    faPlus, faSearch, faRedo, faUserSlash, faUserAlt,
    faTrash, faPen
} from '@fortawesome/free-solid-svg-icons';
import Alert from 'react-s-alert';
import AddUsers from '../Users/AddUsers';
import FailureAlert from '../Common/Failure';
import { ThemeContext } from '../Common/ThemeProvider';
import {
    DeleteUser, ResetPassword,
    UserStatus, GetUserPhoto,
    FetchUsersByID, FetchUsers
} from '../Common/Services/UserService';
import moment from 'moment';
import { CallBackAlert } from '../Common/Validations/validation';
import IsUndefinedNullOrEmpty from '../Common/Validations/valueCheck';
import UserOrgDetails from './UserOrgDetails';

const Users = () => {
    const { CurrentTheme } = useContext(ThemeContext);
    const [usersData, setusersData] = useState([]);
    const [userEditData, setuserEditData] = useState([]);
    const [displayAddUsers, setdisplayAddUsers] = useState("none");
    const [IsEdit, setIsEdit] = useState(0);
    const [FilterUsers, setFilterUsers] = useState([]);
    const [ProfilePhoto, setProfilePhoto] = useState(null);
    const [displayPhotoDetails, setdisplayPhotoDetails] = useState("none");
    const [IsAdmin, setIsAdmin] = useState(false);

    useEffect(() => {
        FetchUsersData();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const columns = [
        {
            name: "User",
            width: "300px",
            wrap: true,
            selector: (row) => {
                return <div className="d-flex align-items-center p-1">
                    <div className="flex-shrink-0">
                        <div className="avatar avatar-sm avatar-circle">
                            {row.Photo ? (<div style={{ borderRadius: "30px" }} className="cursor" title="Click to see Profile Photo..." onClick={() => OnUserPhoto(row.Photo ? row.Photo : null)}><img width="45" height="45" alt="Logo" src={`${baseURL}UserLogo/${row.Photo}`}></img></div>) :
                                (<div style={{ borderRadius: "30px" }} className="avatar-soft-danger">
                                    <span className='avatar-initials cursor'>{`${row.FirstName.charAt(0)}${row.LastName.charAt(0)}`}
                                    </span></div>)}
                        </div>
                    </div>
                    <div className="flex-grow-1 ml-2 text-left">
                        <span className="mb-0" style={{ fontWeight: "600" }}>{`${row.FirstName} ${row.LastName}`}</span>
                        <span style={{ color: "rgb(103, 119, 136)" }} className='d-block fs-5'>{row.EmailID}</span>
                    </div>
                </div>
            }
        },
        {
            name: 'UserName',
            wrap: true,
            selector: row => row.UserName,
            sortable: true,
        },
        {
            name: 'Phone',
            wrap: true,
            selector: (row, index) => {
                return <span style={{ fontSize: "0.75rem" }} className="badge bg-soft-success text-primary rounded-pill">
                    <a style={{ fontWeight: "600", textDecoration: "none" }} href={`tel:+91${row.PhoneNumber}`}>{row.PhoneNumber}</a>
                </span>
            },
        },
        {
            name: 'Role',
            wrap: true,
            selector: row => <span style={{ fontSize: "1rem", fontWeight: "600" }}>{row.Role[0].Name}</span>,
            sortable: true,
        },
        {
            name: 'Created On',
            wrap: true,
            selector: row => moment(row.createdAt).local().format("DD/MM/YYYY"),
            sortable: true,
        },
        {
            name: 'Status',
            width: "80px",
            wrap: true,
            selector: (row) => {
                return row.Status === 1 ? <span className="legend-indicator bg-success"></span> :
                    <span className="legend-indicator bg-danger"></span>
            },
            sortable: true,
        },
        {
            name: 'Action',
            width: "150px",
            selector: (row) => {
                return (
                    <div>
                        <span className="cursorpointer" title="Edit" onClick={(userDetails) => EditSelectedUsers(row)}><FontAwesomeIcon style={{ color: "#147a6f", marginRight: "15px" }} icon={faPen} /></span>
                        {IsAdmin && (<span className="cursorpointer" title="Delete" onClick={(userID) => DeleteSelectedUser(row._id)}><FontAwesomeIcon style={{ color: "#f61414", marginRight: "15px" }} icon={faTrash} /></span>)}
                        {IsAdmin && row.Role && row.Role.length > 0 && row.Role[0].Name.toUpperCase() !== "ADMIN" && (<span className="cursorpointer" title={(row.Status === 1 ? "Disable User" : "Activate User")} onClick={(userID) => SelectedUserStatus(row._id, row.Status)}>
                            <FontAwesomeIcon style={{ color: (row.Status === 0 ? "#ff5511" : "#00c000"), marginRight: "15px" }} icon={(row.Status === 0 ? faUserSlash : faUserAlt)} />
                        </span>)}
                        {IsAdmin && (<span className="cursorpointer" title="Reset Password ( UserPassword@1 )" onClick={(userID) => ResetSelectedUserPassword(row._id)}>
                            <FontAwesomeIcon style={{ color: "#00c000", marginRight: "15px" }} icon={faRedo} />
                        </span>)}
                    </div>
                )
            }
        }
    ];

    const ExpandOrgDetails = ({ data }) => {
        return (
            <div style={{ margin: "10px" }}>
                {data.Organization && data.Organization.length > 0 &&
                    (
                        <UserOrgDetails data={data}></UserOrgDetails>
                    )}
            </div>
        )
    }

    const onUsersSearch = (searchValue) => {
        if (!IsUndefinedNullOrEmpty(searchValue)) {
            let userSearchData = usersData.filter(c => c.FirstName.trim().toLowerCase().includes(searchValue.trim().toLowerCase()) ||
                c.LastName.trim().toLowerCase().includes(searchValue.trim().toLowerCase()) ||
                c.UserName.trim().toLowerCase().includes(searchValue.trim().toLowerCase()) ||
                (c.Organization.length > 0 && c.Organization[0].Keywords !== null && c.Organization[0].Keywords.trim().toLowerCase().includes(searchValue.trim().toLowerCase())) ||
                (c.Organization.length > 0 && c.Organization[0].City !== null && c.Organization[0].City.trim().toLowerCase().includes(searchValue.trim().toLowerCase())));
            setFilterUsers(userSearchData);
        }
        else {
            setFilterUsers(usersData);
        }
    };

    const showUsers = () => {
        setdisplayAddUsers("block");
        setIsEdit(0);
    };

    const hideUser = () => {
        setdisplayAddUsers("none");
    };

    const EditSelectedUsers = (userDetails) => {
        setuserEditData(userDetails);
        setIsEdit(1);
        setdisplayAddUsers("block");
    };

    const DeleteSelectedUser = (UserID) => {
        const userData = localStorage.getItem("userData") ? JSON.parse(localStorage.getItem("userData")) : null;
        if (userData && userData._id && userData._id !== UserID) {
            DeleteUser({ ID: UserID }, UserDeleteSuccess, Failure);
        }
        else {
            Alert.error("Cannot delete logged in User.", {
                position: 'bottom-right',
                effect: 'slide',
                html: false
            });
        }
    };

    const ResetSelectedUserPassword = (UserID) => {
        ResetPassword({ ID: UserID, NewPassword: "UserPassword@1" }, UserDeleteSuccess, Failure);
    };

    const hidePhotoDetails = () => {
        setdisplayPhotoDetails("none");
    };

    const SelectedUserStatus = (UserID, status) => {
        UserStatus({ ID: UserID, Status: (status === 1 ? 0 : 1) }, UserDeleteSuccess, Failure);
    }

    const UserDeleteSuccess = (data) => {
        if (data.success) {
            FetchUsersData();
        }

        CallBackAlert(data);
    };

    const Failure = (err) => {
        FailureAlert(err);
    };

    const OnUserPhoto = (file) => {
        if (file !== null) {
            GetUserPhoto({ fileName: file }, UserImageSuccess, Failure);
        }
    };

    const UserImageSuccess = (data) => {
        setdisplayPhotoDetails("block");
        setProfilePhoto(data);
    };

    const FetchUsersData = () => {
        const userData = localStorage.getItem("userData") ? JSON.parse(localStorage.getItem("userData")) : null;
        if (userData !== null && userData.Role.length > 0 && userData.Role[0].Name.toUpperCase() !== "ADMIN") {
            setIsAdmin(false);
            FetchUsersByID({ _id: userData._id }, UserSuccess, Failure);
        }
        else {
            setIsAdmin(true);
            FetchUsers(null, UserSuccess, Failure);
        }
    };

    const UserSuccess = (data) => {
        setusersData(data);
        setFilterUsers(data);
    };

    return (
        <div>
            <Header></Header>

            <div style={{ border: "none", boxShadow: "none" }} className="container-fluid InvoiceTheme sidemenu-show">
                <div className="row">
                    <div className="offset-md-2 col-md-4 col-sm-4">
                        <h5 className="align-right responsive-align" style={{ fontWeight: "500" }}>MFI Users</h5>
                    </div>
                    {IsAdmin && (<div className="offset-md-2 col-md-3 col-sm-6 col-10" style={{ display: "flex" }}>
                        <input type="text" name="Name" placeholder="Search User..."
                            className="form-control" style={{ marginRight: "10px", borderRadius: "20px", paddingLeft: "40px" }}
                            onChange={e => onUsersSearch(e.target.value)}></input>
                        <div className={`${CurrentTheme}Color`} style={{ fontSize: "1rem", position: "absolute", left: "9%", top: "17%" }}>
                            <FontAwesomeIcon icon={faSearch} />
                        </div>
                    </div>)}
                    {IsAdmin && (<div className="col-md-1 col-sm-2 col-2 align-left">
                        <span data-tip="Add User" className={`cursor font-size-15rem addIconFocus ${CurrentTheme}Color`} onClick={showUsers}>
                            <FontAwesomeIcon icon={faPlus} />
                        </span>
                    </div>)}
                </div>
                <div className="row dtTable" style={{ padding: "15px" }}>
                    <DataTable columns={columns} data={FilterUsers} expandDetails={ExpandOrgDetails}></DataTable>
                </div>
                {displayAddUsers === "block" && <AddUsers themeColor={CurrentTheme} hideuser={hideUser} getUser={FetchUsersData} edit={IsEdit} userdetail={userEditData} allUser={usersData}></AddUsers>}
            </div>
            <div id="myProfilePicnModel" className="modal" style={{ display: displayPhotoDetails, paddingTop: "60px" }}>
                <div className="modal-content">
                    <div className={`modal-header header-style align-center ${CurrentTheme}`}>
                        <span style={{ marginLeft: "5px", padding: "5px" }}>User Profile Picture</span>
                        <span className="close" onClick={hidePhotoDetails}>&times;</span>
                    </div>
                    <div className="align-center">
                        <img width="250px" height="250px" alt="user" src={ProfilePhoto}></img>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Users;